// extracted by css-extract-rspack-plugin
export default {"cls1":"RatingCard-cls1_mJz","cls2":"RatingCard-cls2_YI_ RatingCard-cls1_mJz"};